import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "use-cases-for-pdf-embed-api"
    }}>{`Use cases for PDF Embed API`}</h2>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "../use-cases/collaboration/student-teacher-collaboration/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8742d6c8c016a64c80c5edcd9b746f23/24599/student-teacher-collaboration.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8742d6c8c016a64c80c5edcd9b746f23/a6b7e/student-teacher-collaboration.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/8742d6c8c016a64c80c5edcd9b746f23/a6b7e/student-teacher-collaboration.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "student-teacher-collaboration"
    }}>{`Student teacher collaboration`}</h3>
    <p>{`Accelerate digital learning programs with embedded PDF viewing for teacher and peer document collaboration.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "../use-cases/collaboration/review-and-approval/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5de37d1146b2a904d0d8451df054843f/24599/reviews-and-approvals.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5de37d1146b2a904d0d8451df054843f/a6b7e/reviews-and-approvals.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/5de37d1146b2a904d0d8451df054843f/a6b7e/reviews-and-approvals.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "reviews-and-approvals"
    }}>{`Reviews and approvals`}</h3>
    <p>{`Maximize remote worker productivity with multi-user document collaboration including commenting, markup, text edits, and more.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "../use-cases/content-publishing/digital-content-publishing/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/24599/content-republishing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "digital-content-publishing"
    }}>{`Digital content publishing`}</h3>
    <p>{`Easily republish in different formats by extracting structured content elements such as headings, lists, paragraphs, fonts, and character styling.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    {/* [](/use-cases/report-creation-editing) Faced 404 issue*/}
    <p><a parentName="p" {...{
        "href": "../use-cases/content-publishing/on-demand-report-creation/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/24599/report-creation-editing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/a6b7e/report-creation-editing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/a6b7e/report-creation-editing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "report-creation-and-editing"
    }}>{`Report creation and editing`}</h3>
    <p>{`Create and embed reports for internal or external consumption, sharing, and review.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      